// extracted by mini-css-extract-plugin
export var black = "_4g-6";
export var brand = "_4g-1";
export var ddefault = "_4g-0";
export var error = "_4g-3";
export var gray = "_4g-2";
export var highContrast = "_4g-8";
export var outline = "_4g-7";
export var success = "_4g-5";
export var warning = "_4g-4";